import BlogPosts from "pages/MyBlogs/blogPosts";

export default function() {
    return <BlogPosts/>
}